import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import LoginForm from "./LoginForm";
import { login } from "../actions/identity";
import identitySelectors from "../selectors/identity";
import { AuthOrigin, useOAuth } from "../hooks/useOAuth";
import queryString from "query-string";
import { LoginFailureMessage } from "./LoginFailureMessage";

export const ConnectedLoginForm = ({ site, allowRememberMe, usernameLabel }: any) => {
  const query = queryString.parse(window.location.search);
  const loginForm = useForm({
    defaultValues: {
      email: "",
      password: "",
      remember: true,
    },
  });
  const dispatch = useDispatch();
  const submit = ({ email, password }: any) => {
    dispatch(login({ email, password }));
  };

  const { initiateOAuth, error } = useOAuth({ isEmployee: false, authOrigin: AuthOrigin.Login });

  const postLogin = useSelector(identitySelectors.postLogin);
  const loginFailure = postLogin.error || error || query.authErr;

  return (
    <FormProvider {...loginForm}>
      {loginFailure ? <LoginFailureMessage /> : null}
      <LoginForm
        site={site}
        initiateOAuth={initiateOAuth}
        onSubmit={submit}
        username={{ label: usernameLabel, placeholder: "Email" }}
        allowRememberMe={allowRememberMe}
      />
    </FormProvider>
  );
};
